/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortfolioPeriod
 */
export interface PortfolioPeriod {
    /**
     * 
     * @type {Date}
     * @memberof PortfolioPeriod
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioPeriod
     */
    endDate?: Date;
}

/**
 * Check if a given object implements the PortfolioPeriod interface.
 */
export function instanceOfPortfolioPeriod(value: object): value is PortfolioPeriod {
    return true;
}

export function PortfolioPeriodFromJSON(json: any): PortfolioPeriod {
    return PortfolioPeriodFromJSONTyped(json, false);
}

export function PortfolioPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioPeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
    };
}

export function PortfolioPeriodToJSON(value?: PortfolioPeriod | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
    };
}

